import { createReducer, on } from '@ngrx/store';

import { ModalState } from '../../types';
import {
  closeDropShipModal,
  closeRejectReviewerModal,
  closeRequestReviewerModal,
  makePendingDropShipModal,
  makePendingRejectReviewerModal,
  makePendingRequestReviewerModal,
  openDropShipModal,
  openRejectReviewerModal,
  openRequestReviewerModal,
} from '../actions/basket-modals.actions';

export const basketModalsFeatureKey = 'modals';

export interface State {
  dropShip: ModalState;
  requestReviewer: ModalState;
  rejectReviewer: ModalState;
}

export const initialState: State = {
  dropShip: 'closed',
  requestReviewer: 'closed',
  rejectReviewer: 'closed',
};

export const reducer = createReducer(
  initialState,
  on(
    openDropShipModal,
    (state): State => ({
      ...state,
      dropShip: 'opened',
    }),
  ),
  on(
    closeDropShipModal,
    (state): State => ({
      ...state,
      dropShip: 'closed',
    }),
  ),
  on(
    makePendingDropShipModal,
    (state): State => ({
      ...state,
      dropShip: 'pending',
    }),
  ),
  on(
    openRequestReviewerModal,
    (state): State => ({
      ...state,
      requestReviewer: 'opened',
    }),
  ),
  on(
    closeRequestReviewerModal,
    (state): State => ({
      ...state,
      requestReviewer: 'closed',
    }),
  ),
  on(
    makePendingRequestReviewerModal,
    (state): State => ({
      ...state,
      requestReviewer: 'pending',
    }),
  ),
  on(
    openRejectReviewerModal,
    (state): State => ({
      ...state,
      rejectReviewer: 'opened',
    }),
  ),
  on(
    closeRejectReviewerModal,
    (state): State => ({
      ...state,
      rejectReviewer: 'closed',
    }),
  ),
  on(
    makePendingRejectReviewerModal,
    (state): State => ({
      ...state,
      rejectReviewer: 'pending',
    }),
  ),
);
